// extracted by mini-css-extract-plugin
export var acceptButton = "_1f-6";
export var backdropBlur = "_1f-0";
export var fullContent = "_1f-5";
export var link = "_1f-7";
export var linkIcon = "_1f-8";
export var sideContent = "_1f-4";
export var sideImage = "_1f-3";
export var sideImageWrapper = "_1f-2";
export var splitLayout = "_1f-1";